<template>
    <div class="pb-3 flex-grow-1">
        <div v-show="$store.state.loading">
            <b-spinner class="align-middle text-info"></b-spinner>
        </div>
        <div v-show="!$store.state.loading" :class="{'content-center': createdShipment}">
            <ShipmentSummary />
            <!-- <div class="d-flex justify-content-end pt-4 pb-4">
                <b-btn variant="primary-user"
                       @click="createNewPlan">
                    Create a new Shipping plan
                </b-btn>
                <b-btn variant="primary-user"
                       class="ml-2"
                       :to="{name: 'InventoryReplenishment'}">
                    Open Replenishment shipments list
                </b-btn>
            </div> -->
        </div>
    </div>
</template>

<script>
    import {getPDF} from 'api/services'
    import ShipmentSummary from '../ShipmentSummary'

    export default {
        name: 'Step4',
        components: {ShipmentSummary},
        filters: {
            capitalize(value) {
                return value.charAt(0).toUpperCase() + value.slice(1)
            }
        },
        data() {
            return {
                planData: this.$route.params.planData,
                parcels: [],
                createdShipment: false,
                documentCreated: false
            }
        },
        computed: {
            address() {
                return this.$route.params.planData.address
            }
        },
        created() {
            if (!this.$route.params.planData) {
                this.getPlanData()
            }
            this.getPlanParcels()
        },
        methods: {
            getPlanData() {
                this.$api('GET', this.$endpoints.income(this.$route.params.planId)).then(response => { this.planData = response })
            },
            getPlanParcels() {
                this.$api('GET', this.$endpoints.incomesParcels(this.$route.params.planId)).then(response => { this.parcels = response })
            },
            printDocuments() {
                getPDF(this.$endpoints.printShipment(this.$route.params.planId), null, `shipment-${this.$route.params.planId}`)
                    .then()
                    .catch(() => {
                        this.$store.dispatch('globalAlertAction', {
                            type: 'error',
                            title: 'Error'
                        })
                        this.$store.commit('SET_LOADING', false)
                    })
            },
            // createNewPlan() {
            //     this.$store.dispatch('createPlan').then(response => {
            //         this.$router.push({
            //             name: 'ReplenishmentAddProducts',
            //             params: {
            //                 planId: response.id,
            //                 parent: 'plans',
            //                 parentBred: {
            //                     route: this.$route
            //                 }
            //             }
            //         })
            //     })
            // }
        }
    }
</script>

<style lang="scss" scoped>
    h4,
    .h4,
    h5,
    .h6 {
        font-weight: bold;
    }

    .content-center {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        height: 100%;
    }

    .address-box {
        h6 {
            margin: 0;
        }
        padding-bottom: 25px;
    }

    .parcel-box {
        display: flex;

        &__col {
            flex: 00140px;
            min-width: 140px;

            &:not(:first-child) {
                .parcel-cell {
                    text-align: center;
                }
            }
        }

        .parcel-cell {
            font-weight: bold;
            font-size: 14px;
            padding: 15px;
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/UserPanel/Pages/Inventory/Replenishment/Shipment/CreateShipment/Step4.vue